var render = function render() {
  var _vm$$attrs;
  var _vm = this,
    _c = _vm._self._c;
  return _c('Drawer', _vm._g({
    ref: "drawer",
    attrs: {
      "prevent-scroll": "",
      "layout": (_vm$$attrs = _vm.$attrs) === null || _vm$$attrs === void 0 ? void 0 : _vm$$attrs.layout
    },
    on: {
      "closed": _vm.handleClosed
    }
  }, _vm.$listeners), [_c(_vm.agentProfileStore.stateProfile, {
    tag: "component",
    class: {
      'in-modal-profile': _vm.screen.lg
    },
    on: {
      "exit": _vm.handleClose
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };